/**
 * SplitContainer parser: the shared SplitContainer base plus `vertical`, which this base serialises
 * and its fixed-axis subclasses do not (`types.ts`).
 */
import { parseOptionalBool } from '../../../../parser/valueParsers';
import { parseSplitContainer as parseSharedSplitContainer } from '../shared/splitContainer';
export function parseSplitContainer(heading, properties) {
    const result = { ...parseSharedSplitContainer(heading, properties) };
    result.vertical = parseOptionalBool(properties.vertical);
    return result;
}
//# sourceMappingURL=parser.js.map